// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"b0f27cc6","238":"9480863f","282":"588f785e","341":"818aba0a","549":"16fae329","561":"6e150cb4","581":"2293af22","657":"e9631dbb","697":"b9b9e1a3","811":"e30807fd","854":"91b83a1b","872":"f99069fb","956":"b39ae050","968":"767afff1"}[chunkId] + ".chunk.js";
};